import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/services/pentesting/page.tsx");
